import { images } from '../constants';
 
const services = [ 
    {
        id: 1,
        image: images.service1,
        title: 'City Rides',
        content: 'Reliable and convenient rides within the city. Perfect for commuting, errands, and local events.',
        paragraphs: [
            'Our city ride services offer quick, safe, and affordable transportation across the city. Whether you need a ride to work, a shopping trip, or a night out, our taxis are available 24/7 to meet your needs.',
            'With professional drivers and well-maintained vehicles, we ensure a smooth and enjoyable journey. Choose from a range of ride options, including standard, luxury, and shared rides, tailored to your preferences.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: {
            intro: 'Why choose our city ride services?',
            list: [
                '24/7 availability for any destination',
                'Professional and experienced drivers',
                'Affordable and transparent pricing',
                'Comfortable and clean vehicles',
                'Fast and reliable transportation'
            ]
        },
        process: {
            intro: 'How our city ride booking works:',
            list: [
                'Enter your pickup and drop-off locations',
                'Select your preferred ride type',
                'Confirm the fare and book your ride',
                'Track your ride in real-time',
                'Arrive safely and enjoy your trip'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'How do I book a city ride?',
                content: 'You can book a city ride through our website or mobile app. Simply enter your pickup and drop-off locations, select your ride type, and confirm your booking.'
            },
            {
                id: 2,
                heading: 'Are your taxi fares fixed?',
                content: 'Our fares are transparent and calculated based on distance and ride type. You’ll see the estimated fare before confirming your booking.'
            },
            {
                id: 3,
                heading: 'Do you offer shared rides?',
                content: 'Yes, we offer shared rides to make travel more affordable and eco-friendly. Choose this option when booking your ride.'
            },
            {
                id: 4,
                heading: 'Can I schedule a ride in advance?',
                content: 'Absolutely! You can pre-book your taxi for a future date and time through our platform for added convenience.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Airport Transfers',
        content: 'Comfortable and timely transfers to and from the airport. Hassle-free travel for your flights.',
        paragraphs: [
            'Our airport transfer service provides hassle-free transportation, ensuring you arrive on time and in comfort. Whether you need a pickup or drop-off, we offer punctual and professional service tailored to your schedule.',
            'We provide a fleet of well-maintained vehicles with professional drivers who monitor flight schedules to accommodate any changes. Enjoy a stress-free ride with our airport transfer solutions, whether for business or leisure travel.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: {
            intro: 'Experience the convenience of our airport transfer services, ensuring a seamless and timely journey.',
            list: [
                'Punctual and professional service',
                'Comfortable and well-maintained vehicles',
                'Real-time flight tracking for timely pickups',
                'Affordable and transparent pricing',
                'Available 24/7 for your convenience'
            ]
        },
        process: {
            intro: 'Our streamlined booking and transfer process ensures an efficient and stress-free experience.',
            list: [
                'Easy online booking or phone reservation',
                'Flight tracking to adjust for delays',
                'Professional driver assigned for pickup',
                'Comfortable and safe ride to your destination',
                'Drop-off at the designated location on time'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'How do I book an airport transfer?',
                content: 'You can book online through our website or call our customer service for assistance. We recommend booking in advance for the best availability.'
            },
            {
                id: 2,
                heading: 'What happens if my flight is delayed?',
                content: 'We track flight schedules and adjust pickup times accordingly, ensuring that you have a driver waiting when you land.'
            },
            {
                id: 3,
                heading: 'Are your drivers professionally trained?',
                content: 'Yes, all our drivers are licensed professionals with extensive experience in airport transfers and customer service.'
            },
            {
                id: 4,
                heading: 'Can I request a specific type of vehicle?',
                content: 'Yes, we offer a range of vehicle options to suit your needs, from standard sedans to luxury cars and larger vehicles for groups.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Corporate Rides',
        content: 'Professional and efficient rides tailored for business meetings, conferences, and corporate events.',
        paragraphs: [
            'Our corporate ride services are tailored for business professionals who require reliability, comfort, and efficiency. Whether you need transportation for meetings, events, or daily commutes, we provide a seamless experience.',
            'Enjoy a fleet of executive vehicles equipped with Wi-Fi, leather seats, and professional chauffeurs who prioritize your schedule and convenience. We understand the importance of time in the corporate world, and our services are designed to keep you on track.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: {
            intro: 'Experience the ultimate corporate travel solution with our premium ride services.',
            list: [
                'Executive-class vehicles for a comfortable ride',
                'Professional chauffeurs ensuring punctuality',
                'On-demand or scheduled bookings',
                'Secure and confidential travel',
                'Flexible plans for businesses of all sizes'
            ]
        },
        process: {
            intro: 'Our streamlined process ensures a smooth and professional corporate travel experience.',
            list: [
                'Easy online booking and scheduling',
                'Customized corporate travel plans',
                'Real-time tracking and updates',
                'Premium customer support',
                'Seamless invoicing and payment options'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'Can I set up a corporate account?',
                content: 'Yes, we offer corporate accounts with flexible billing and priority services. Contact us for details.'
            },
            {
                id: 2,
                heading: 'Do you provide long-distance corporate rides?',
                content: 'Absolutely! Our corporate rides cover both short and long-distance trips to meet your business needs.'
            },
            {
                id: 3,
                heading: 'Are your chauffeurs professionally trained?',
                content: 'Yes, all our chauffeurs undergo professional training to provide the highest level of service and safety.'
            },
            {
                id: 4,
                heading: 'Can I request specific vehicle models?',
                content: 'Yes, we offer a range of executive vehicles, and you can request a specific model based on availability.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Luxury Rides',
        content: 'Experience top-of-the-line vehicles and premium services for a sophisticated and comfortable ride.',
        paragraphs: [
            'Our luxury rides offer a premium experience with high-end vehicles and professional chauffeurs. Whether you need transportation for a special occasion or just prefer a stylish ride, we have the perfect solution for you.',
            'Enjoy plush interiors, complimentary refreshments, and top-tier service, ensuring a seamless and relaxing journey every time you book with us.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: {
            intro: 'Why choose our luxury rides?',
            list: [
                'High-end vehicles with premium interiors',
                'Professional and courteous chauffeurs',
                'Complimentary refreshments and Wi-Fi',
                'Perfect for special occasions and business travel',
                'Reliable and punctual service'
            ]
        },
        process: {
            intro: 'Our luxury ride process ensures a smooth and stress-free experience.',
            list: [
                'Effortless booking through our website or app',
                'Selection of premium vehicles to suit your needs',
                'On-time pickup and drop-off with professional service',
                'Luxurious and comfortable journey with added amenities',
                'Final quality check to ensure complete satisfaction'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'What types of luxury vehicles do you offer?',
                content: 'We provide a range of high-end vehicles, including limousines, executive sedans, and luxury SUVs, to match your preferences and needs.'
            },
            {
                id: 2,
                heading: 'Can I request a specific chauffeur?',
                content: 'Yes, we offer personalized chauffeur selection for frequent clients to ensure a consistent and familiar service experience.'
            },
            {
                id: 3,
                heading: 'Do you provide corporate luxury ride services?',
                content: 'Absolutely! We cater to corporate clients, offering executive transport solutions for meetings, events, and airport transfers.'
            },
            {
                id: 4,
                heading: 'How do I book a luxury ride?',
                content: 'You can book through our website or mobile app by selecting your preferred luxury vehicle, date, and time.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Group Rides',
        content: 'Spacious vehicles for groups and events. Perfect for family outings, parties, and large gatherings.',
        paragraphs: [
            'Travel together with ease using our group ride services. Whether you’re heading to an event, a family gathering, or a corporate function, we provide spacious and comfortable vehicles to accommodate your group.',
            'Enjoy a hassle-free journey with professional drivers, ample seating, and a smooth booking process, ensuring everyone reaches their destination together and on time.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: {
            intro: 'Why choose our group ride services?',
            list: [
                'Spacious vehicles for small to large groups',
                'Professional and experienced drivers',
                'Affordable rates with cost-sharing options',
                'Perfect for events, corporate travel, and family trips',
                'Easy booking and real-time tracking'
            ]
        },
        process: {
            intro: 'How our group ride service works:',
            list: [
                'Simple online booking for groups of any size',
                'Selection of spacious vans, minibusses, or SUVs',
                'On-time pickup from multiple locations if needed',
                'Comfortable and enjoyable ride with ample space',
                'Safe and timely arrival at your destination'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'How many passengers can a group ride accommodate?',
                content: 'We offer different vehicle sizes, ranging from SUVs for small groups to minibusses for larger parties. Contact us to find the right fit for your group.'
            },
            {
                id: 2,
                heading: 'Can we book multiple pickup locations?',
                content: 'Yes, we offer flexible pickup options to accommodate your group’s needs. Let us know your requirements when booking.'
            },
            {
                id: 3,
                heading: 'Is group ride pricing per person or per vehicle?',
                content: 'Our pricing is typically per vehicle, making it a cost-effective option when splitting costs among passengers.'
            },
            {
                id: 4,
                heading: 'How do I book a group ride?',
                content: 'You can book a group ride through our website or mobile app, selecting the appropriate vehicle size and providing trip details.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Shuttle Services',
        content: 'Convenient shuttle services for regular routes, including airport shuttles, hotel transfers, and more.',
        paragraphs: [
            'Our shuttle services provide convenient and affordable transportation for individuals and groups. Whether you need a daily commute option or a shuttle for a special event, we offer flexible and scheduled transport solutions.',
            'With professional drivers and well-maintained vehicles, we ensure a safe, punctual, and comfortable travel experience, making your journey stress-free.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: {
            intro: 'Why choose our shuttle services?',
            list: [
                'Scheduled and on-demand shuttle options',
                'Comfortable seating and climate control',
                'Ideal for corporate, airport, and event transportation',
                'Affordable pricing with multiple route options',
                'Real-time tracking and easy booking'
            ]
        },
        process: {
            intro: 'How our shuttle service works:',
            list: [
                'Book your shuttle service online or via our app',
                'Choose from daily, weekly, or event-based routes',
                'Enjoy comfortable and hassle-free travel',
                'Real-time tracking to monitor shuttle arrival times',
                'Reliable drop-off at your designated destination'
            ]
        },
        faqs: [
            {
                id: 1,
                heading: 'Do you offer airport shuttle services?',
                content: 'Yes, we provide airport shuttle services with flexible scheduling to ensure you arrive on time for your flight.'
            },
            {
                id: 2,
                heading: 'Can I book a private shuttle for an event?',
                content: 'Absolutely! We offer private shuttle services for corporate events, weddings, and other group gatherings.'
            },
            {
                id: 3,
                heading: 'Are your shuttle services available 24/7?',
                content: 'Some of our shuttle routes operate 24/7, while others follow a set schedule. Please check availability for your specific route.'
            },
            {
                id: 4,
                heading: 'How do I reserve a shuttle seat?',
                content: 'You can reserve a seat through our website or mobile app by selecting your preferred route, date, and time.'
            }
        ]
    }
    
];

export default services;